import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../apis/auth"; // Import the loginUser function

function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await loginUser({ email, password }); // Call the login API
      const token = response.data?.data?.token; // Extract the token from the response
  
      if (token) {
        localStorage.setItem("authToken", token); // Save the token in localStorage
        console.log("Login successful, token saved:", token);
  
        // Navigate to Dashboard after login
        navigate("/dashboard");
      } else {
        console.error("Login failed: Token not received");
        alert("Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Error during login:", err);
      alert("Invalid email or password. Please try again.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className="main flex w-full h-full">
      {/* Form */}
      <div className="w-1/2 mt-auto mb-auto ml-auto mr-auto">
        <div style={{ width: "420px", height: "560px" }} className="ml-auto mr-auto">
          {/* Logo */}
          <div className="flex items-center">
            <div>
              <img src="/image/Vector.png" alt="logo" />
            </div>
            <div className="pl-4">
              <img src="image/FasTrack Logistics.png" alt="text" />
            </div>
          </div>

          {/* Heading */}
          <h3 className="font-bold text-3xl text-gray-700 mt-[40px]">
            Sign In to Your Account
          </h3>
          <p className="text-gray-500 mt-4 text-base">
            Sign in to easily manage clients, track their orders, and streamline
            operations.
          </p>

          {/* Form */}
          <form className="mt-[62px]" onSubmit={handleSubmit}>
            <div className="border rounded-lg">
              <label className="block p-3 text-gray-600 text-sm font-medium">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-3 pb-2 border-none rounded-lg font-bold focus:outline-none"
                placeholder="luis.albert@gmail.com"
              />
            </div>
            <div className="border rounded-lg mt-3">
              <label className="block pl-3 pt-2 pb-2.5 text-gray-600 text-sm font-medium">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-3 pt-2 pb-2 font-bold border-none rounded-lg focus:outline-none"
                  placeholder="••••••••••••••"
                />
                <span
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-4 flex items-center text-gray-400 cursor-pointer"
                >
                  👁️
                </span>
              </div>
            </div>
            <button
              type="submit"
              className="w-full mt-[60px] bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>

      {/* Image */}
      <div className="w-1/2 h-screen overflow-hidden">
        <img
          src="/image/logistics-transportation-container-cargo-ship-cargo-plane-with-working-crane-bridge-shipyard-sunrise-logistic-import-export-transport-industry-background-ai-generative.png"
          alt="Sample"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
}

export default LoginPage;